import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Collapse,
  Tooltip,
} from "@material-ui/core";
import {
  IoIosArrowDroprightCircle,
  IoIosArrowDropdownCircle,
} from "react-icons/io";
import Contactus from "../../../Component/Support/contactus";
import { LangContext } from "../../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    backgroundColor: "#FFFFFF",
  },
  question: {
    height: "68%",
    width: "100%",
    paddingTop: "2rem",
    paddingBottom: "5rem",
  },
  contact: {
    height: "32%",
    width: "85%",
    backgroundColor: "#fcfcfb",
    // paddingTop: "2rem",
    // paddingBottom: "2rem",
    padding: "2rem",
  },
  component: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  faq: {
    height: "85%",
    width: "75%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  cardstyle: {
    width: "100%",
    borderRadius: 8,
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
  },
  componentaround: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    // padding: "1rem",
    marginBottom: "2rem",
  },
  questioncomponent: {
    height: "100%",
    width: "75%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "space-around",
    paddingTop: "2rem",
  },
  maintext: {
    color: "#595A5A",
    fontSize: "2rem",
    textAlign: "center",
  },
  secondtext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    maxWidth: 860,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  itemmain: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  image: {
    width: "10rem",
    height: "auto",
    padding: "2rem",
    cursor: "pointer",
  },
  collapseStyle: {
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    borderRadius: 8,
    boxShadow: "unset",
    backgroundColor: "#F8F8F8",
  },
  webboard: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    cursor: "pointer",
    marginLeft: 10,
    "&:hover": {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
}));

const Anyquestion = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  let [list, setlist] = useState([
    { title: `${lang.Question} 1`, expand: false },
    { title: `${lang.Question} 2`, expand: false },
    { title: `${lang.Question} 3`, expand: false },
    { title: `${lang.Question} 4`, expand: false },
  ]);

  const goWebboard = () => {
    let a = document.createElement("a");
    a.href = "https://webboardgis.mea.or.th";
    a.target = "_blank";
    a.click();
  };
  return (
    <div className={classes.root}>
      <Grid container spacing={0} className={classes.question}>
        <Grid item xs={12}>
          <div className={classes.component}>
            <Typography className={classes.maintext}>
              {lang.Doyouhaveanyquestion}
            </Typography>
            <div className={classes.itemmain}>
              <Typography className={classes.secondtext}>
                {lang.SubtitlesDoyouhavequestion}
              </Typography>
              <Typography
                className={classes.webboard}
                onClick={() => {
                  goWebboard();
                }}
              >
                Webboard
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid item md={5} sm={12} xs={12}>
          <div className={classes.component}>
            <div className={classes.faq}>
              <Tooltip
                title={
                  langContext.lang.locale === "th"
                    ? "ไปที่ webboard"
                    : "go to webboard"
                }
                placement="top"
              >
                <img
                  alt="faqimage"
                  src={require("../../../images/graphic-icon/question.png")}
                  className={classes.image}
                  onClick={() => {
                    goWebboard();
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </Grid>
        <Grid
          item
          md={7}
          sm={12}
          xs={12}
          style={{ width: "-webkit-fill-available" }}
        >
          <div className={classes.componentaround}>
            <div className={classes.questioncomponent}>
              {list.map((item, index) => {
                return (
                  <div key={item.title} style={{ width: "100%" }}>
                    <Card className={classes.cardstyle}>
                      <CardActionArea
                        onClick={() => {
                          let data = [...list];
                          data[index].expand = !data[index].expand;
                          setlist(data);
                        }}
                      >
                        <CardContent>
                          <Grid
                            container
                            spacing={0}
                            style={{ justifyContent: "center" }}
                          >
                            <Grid item xs={6}>
                              <Typography
                                style={{
                                  fontWeight: "200",
                                  color: "#595A5A",
                                  fontSize: "1rem",
                                }}
                              >
                                {item.title}
                              </Typography>
                            </Grid>

                            <Grid
                              item
                              xs={6}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                              }}
                            >
                              {item.expand ? (
                                <IoIosArrowDropdownCircle
                                  size={24}
                                  color="#E16733"
                                />
                              ) : (
                                <IoIosArrowDroprightCircle
                                  size={24}
                                  color="#E16733"
                                />
                              )}
                            </Grid>
                          </Grid>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                    <Collapse in={item.expand} timeout="auto" unmountOnExit>
                      <Card className={classes.collapseStyle}>
                        <div style={{ margin: "1rem" }}>
                          <Typography
                            style={{ color: "#595A5A", fontWeight: 200 }}
                          >
                            Question {index}
                          </Typography>
                        </div>
                      </Card>
                    </Collapse>
                  </div>
                );
              })}
            </div>
          </div>
        </Grid>
      </Grid>
      <div className={classes.component} style={{ backgroundColor: "#fcfcfb" }}>
        <Grid container spacing={0} className={classes.contact}>
          <Contactus />
        </Grid>
      </div>
    </div>
  );
};

export default Anyquestion;
